// A mock function to mimic making an async request for data
import liff from '@line/liff';

const testUserId = process.env.REACT_APP_TEST_USER_ID || '';

export function userId() {
  const context = liff.getContext();
  return context?.userId || testUserId;
}
